import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * 31 Oct 2026: /listings/<slug> has a branded, photo-first static page (backend/listings_static.py +
 * property_page.py) served by nginx. In-app <Link> navigation used to render the old React
 * ListingDetail instead (raw "#####" markdown, different look). This forces a real page load of the
 * static page. If we already tried once for this path (static page missing → SPA fallback), render
 * the React fallback instead of looping.
 */
export default function FullPageLoad({ fallback }) {
  const { pathname, search } = useLocation();
  const key = `sofia_fullload:${pathname}`;
  const [tried] = useState(() => { try { return sessionStorage.getItem(key) === "1"; } catch (e) { return false; } });
  useEffect(() => {
    if (tried) return;
    try { sessionStorage.setItem(key, "1"); } catch (e) {}
    window.location.replace(pathname + search);
  }, [tried, key, pathname, search]);
  return tried ? fallback : <div className="min-h-screen bg-bone" aria-busy="true" />;
}
